<template>
  <a-dialog
    v-model="showSignerSelectDialog"
    scrollable
    max-width="800px"
    persistent
  >
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>
            <slot name="heading">
              {{ $t("agenda.lblAddRemoveSigner") }}
            </slot>
          </span>
          <v-spacer></v-spacer>
          <CloseIcon @click="showSignerSelectDialog = false" />
        </v-toolbar>
      </v-banner>

      <v-card-text>
        <v-container style="padding: 0 !important">
          <v-row>
            <v-col cols="12">
              <meeting-participants
                :meetingAtteendeelist.sync="singerList"
                @onSelection="onSignerSelection"
                :label="label"
                :suggestedList="authorizedAttendee"
                type="signer"
                :adHocEmail="false"
              ></meeting-participants>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="primaryDark"
              class="mr-2"
              @click="selectSigner"
              :disabled="newSignerList.length === 0 || isDirty"
            >
              {{ $t("btnAdd") }}
            </a-btn>
          </template>
          <span> {{ $t("agenda.lblAddSelectedSigner") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="secondary"
              @click="showSignerSelectDialog = false"
            >
              {{ $t("widget.close") }}
            </a-btn>
          </template>
          <span> {{ $t("widget.close") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import MeetingParticipants from "../MeetingParticipants.vue";
export default {
  name: "SignerSelect",
  components: { MeetingParticipants },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: String,
    signerList: Array,
    attendeesList: Array,
    signerType: {
      type: String,
      default: 'attendee',
    }
  },
  data() {
    return {
      btnAssignDisable: true,
      newSignerList: [],
    };
  },
  computed: {
    showSignerSelectDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    singerList: {
      get() {
        return this.signerList;
      },
      set(value) {
        this.signerList = value;
      },
    },
     authorizedAttendee(){
      if (!this.attendeesList.length) return [];
      return this.signerType === 'observer'
        ? this.attendeesList
        : this.attendeesList.filter(attendee => attendee.is_authorized);
    },
    isDirty() {
      const signerListEmails = this.signerList.map((obj) => obj.email);
      signerListEmails.sort();
      const newSignerListEmails = this.newSignerList.map((obj) => obj.email);
      newSignerListEmails.sort();
      return (
        JSON.stringify(signerListEmails) == JSON.stringify(newSignerListEmails)
      );
    },
  },
  methods: {
    onSignerSelection,
    selectSigner,
  },
};

function selectSigner() {
  // Helper function to set default properties
  const setDefaultProperties = (obj) => ({
    ...obj,
    signAuthority: obj.signAuthority || "required",
    signLanguage: obj.signLanguage || "ja",
    order: obj.order || null,
  });

  // Set default properties and map to a new array
  const list = this.newSignerList.map(setDefaultProperties);

  // Filter objects with order property
  const objectsWithOrder = list.filter((obj) => obj.order !== null);

  // Find the maximum order value
  const maxOrder = objectsWithOrder.reduce(
    (max, obj) => Math.max(max, obj.order),
    0
  );

  // Assign new order values to objects without order property
  let newOrder = maxOrder + 1;
  const newArray = list.map((obj) => ({
    ...obj,
    order: obj.order === null ? newOrder++ : obj.order,
  }));

  // Emit events
  this.$emit(
    "update:signerList",
    newArray.sort((a, b) => a.order - b.order)
  );
  this.$emit("input", false);
}

function onSignerSelection(signer) {
  // Helper function to extract and format signer data
  const extractSigner = (list) =>
    (list || [])
      .map(({ id, email, emailList = [] }) => ({ id, email, emailList }))
      .sort((a, b) => a.email.localeCompare(b.email));

  // Extract and format original and selected signers
  const originalMeetingSigner = extractSigner(this.signerList);
  const assignSigner = extractSigner(signer);

  // Set btnAssignDisable based on equality of original and selected signers
  this.btnAssignDisable =
    JSON.stringify(originalMeetingSigner) === JSON.stringify(assignSigner);

  // Merge signer data and set to newSignerList
  this.newSignerList = signer.map((obj2) => {
    const matchingObj = this.signerList.find(
      (obj1) => obj1.email === obj2.email
    );

    // Merge properties if matching object exists, otherwise add default properties
    return matchingObj
      ? { ...obj2, ...matchingObj }
      : {
          ...obj2,
          signAuthority: "required",
          signLanguage: "ja",
          order: null,
        };
  });
}

// function selectSigner() {
//   const list = this.newSignerList.map((obj) => ({
//     ...obj,
//     signAuthority: obj.signAuthority || "required",
//     signLanguage: obj.signLanguage || "ja",
//   }));

//   let objectsWithOrder = list.filter((obj) => obj.order !== undefined);

//   // Find the maximum order value
//   let maxOrder = objectsWithOrder.reduce((max, obj) => {
//     return obj.order > max ? obj.order : max;
//   }, 0);

//   // Assign new order values to objects without order property
//   let newOrder = maxOrder + 1;
//   let newArray = list.map((obj) => {
//     if (obj.order === undefined) {
//       obj.order = newOrder++;
//     }
//     return obj;
//   });
//   this.$emit("update:signerList", newArray);
//   this.$emit("input", false);
// }

// function onSignerSelection(signer) {
//   const extractSigner = (list) =>
//     list
//       .map((item) => {
//         return {
//           id: item.id,
//           email: item.email,
//           emailList: item.emailList ? item.emailList : [],
//         };
//       })
//       .sort((a, b) => a.email.localeCompare(b.email)) || [];

//   const originalMeetingSigner = extractSigner(this.signerList);
//   const assignSigner = extractSigner(signer);
//   if (JSON.stringify(originalMeetingSigner) === JSON.stringify(assignSigner)) {
//     this.btnAssignDisable = true;
//   } else {
//     this.btnAssignDisable = false;
//   }
//   let mergedArray = signer.map((obj2) => {
//     let matchingObj = this.signerList.find((obj1) => obj1.email === obj2.email);

//     // If matching object exists, merge its properties with obj2
//     if (matchingObj) {
//       return { ...obj2, ...matchingObj };
//     } else {
//       // If matching object doesn't exist, add default properties
//       return {
//         ...obj2,
//         signAuthority: "required",
//         signLanguage: "ja",
//       };
//     }
//   });
//   this.newSignerList = mergedArray;
// }

function calculateOrder(existingOrders) {
  let maxOrder = Math.max(...existingOrders);
  return maxOrder + 1;
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>